import { ref } from "vue";
import { defineStore } from "pinia";
import axios from "axios";
import { useHttpStore } from "@/stores/http";

export const useRegistrationStore = defineStore("registration", () => {
  const httpStore = useHttpStore();

  const emeaCountries = ref([]);
  const languages = ref([]);


  
  const getInvitations = () => {
    var params = {
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "registration/getInvitations", params, {
          showLoading: true,
        })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };


  const sendUserInvitation = (affinityId, partnerName, firstname, lastname, emailAddress) => {
    if (partnerName == undefined) {
      partnerName = ''
    }
    var params = {
      affinityId,
      partnerName,
      firstname,
      lastname,
      emailAddress
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("post", "registration/SendUserInvitation", params, {
          showLoading: true,
        })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const FindEmailDomainMatch = (email, affinityId) => {
    var params = {
      Email: email,
      AffinityId: affinityId,
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "registration/FindEmailDomainMatch", params, {
          showLoading: true,
        })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const searchAffinityId = (affinityId) => {
    var params = {
      Affinityid: affinityId,
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "registration/SearchAffinityId", params, {
          showLoading: true,
        })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const searchOrganization = (countryName, organizationName) => {
    var params = {
      CountryName: countryName,
      OrganizationName: organizationName,
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "registration/SearchOrganization", params, {
          showLoading: true,
        })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const GetEMEACountries = () => {
    var params = {};
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "countries/GetEMEACountries", params, { showLoading: true })
        .then((res) => {
          if (res.success) {
            emeaCountries.value = res.countries;
          }
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const GetAllLanguages = () => {
    var params = {};
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "registration/GetAllLanguages", params, { showLoading: true })
        .then((res) => {
          if (res.success) {
            languages.value = res.languages;
          }
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const IsExistingUser = (emailAddress) => {
    var params = {
      EmailAddress: emailAddress
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "registration/IsExistingUser", params, { showLoading: true })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const GetOrganizationByAffinityId = (affinityId) => {
    var params = {
      AffinityId: affinityId
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "registration/GetOrganizationByAffinityId", params, { showLoading: true })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const SubmitRegistration = (affinityId, username, firstname, lastname, languageId, telephone, mobile, communicationsOptIn) => {
    var params = {
      AffinityId: affinityId,
      Username:username,
      Firstname:firstname,
      Lastname:lastname,
      LanguageId:languageId,
      Telephone: telephone,
      Mobile: mobile,
      CommunicationsOptIn:communicationsOptIn
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("post", "registration/SubmitRegistration", params, { showLoading: true })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  
  return {
    emeaCountries,
    languages,
    FindEmailDomainMatch,
    searchAffinityId,
    searchOrganization,
    GetEMEACountries,
    GetAllLanguages,
    IsExistingUser,
    GetOrganizationByAffinityId,
    SubmitRegistration,
    sendUserInvitation,
    getInvitations
  };
});
